import React from "react";
import classNames from "classnames/bind";
import styles from "./Products.module.scss";
import Pagination from "../commons/Pagination/Pagination";
import dayjs from "dayjs";

const cx = classNames.bind(styles);

const categories = {
  ko: [
    { id: "", label: "전체" },
    { id: "모노머", label: "모노머" },
    { id: "용제", label: "용제" },
    { id: "기타", label: "기타" },
  ],
  en: [
    { id: "", label: "All" },
    { id: "Monomers", label: "Monomers" },
    { id: "Solvents", label: "Solvents" },
    { id: "Others", label: "Others" },
  ],
};

export default function Products({
  currentPage,
  lastPage,
  perPage,
  total,
  data,
  options,
  handlePage,
  handleOptions,
  handleDelete,
  handleDetailMove,
}) {
  return (
    <>
      <div className={cx("option_container")}>
        <div className={cx("option_inner")}>
          <div className={cx("option_box")}>
            <div className={cx("option_title_box")}>
              <p className={cx("option_title")}>구분</p>
            </div>
            <div className={cx("option_button_box")}>
              <button
                className={cx("option_button", {
                  active: options.locale === "ko",
                })}
                onClick={() => handleOptions("locale", "ko")}
              >
                한국어
              </button>
              <button
                className={cx("option_button", {
                  active: options.locale === "en",
                })}
                onClick={() => handleOptions("locale", "en")}
              >
                영문
              </button>
            </div>
          </div>
          <div className={cx("option_box")}>
            <div className={cx("option_title_box")}>
              <p className={cx("option_title")}>정렬</p>
            </div>
            <div className={cx("option_button_box")}>
              <button
                className={cx("option_button", {
                  active: options.sort === "desc",
                })}
                onClick={() => handleOptions("sort", "desc")}
              >
                최신순
              </button>
              <button
                className={cx("option_button", {
                  active: options.sort === "asc",
                })}
                onClick={() => handleOptions("sort", "asc")}
              >
                오래된순
              </button>
            </div>
          </div>
        </div>
        <div className={cx("option_inner")}>
          <div className={cx("option_box")}>
            <div className={cx("option_title_box")}>
              <p className={cx("option_title")}>카테고리</p>
            </div>
            <div className={cx("option_button_box")}>
              {categories[options.locale].map((cat) => (
                <button
                  key={cat.id}
                  className={cx("option_button", {
                    active: options.category === cat.id,
                  })}
                  onClick={() =>
                    handleOptions(
                      "category",
                      options.category === cat.id ? "" : cat.id
                    )
                  }
                >
                  {cat.label}
                </button>
              ))}
            </div>
          </div>
          <div className={cx("option_box")}>
            <div className={cx("option_title_box")}>
              <p className={cx("option_title")}>검색어</p>
            </div>
            <div className={cx("option_button_box")}>
              <input
                type="text"
                className={cx("input")}
                value={options?.search}
                name="search"
                onChange={(e) => handleOptions("search", e.target.value)}
                placeholder="제품명, CAS_No, 설명을 입력해 주세요."
              />
            </div>
          </div>
        </div>
      </div>
      <div className={cx("table_container")}>
        <table className={cx("table")}>
          <thead>
            <tr>
              <th className={cx("th")}>번호</th>
              <th className={cx("th")}>구분</th>
              <th className={cx("th")}>카테고리</th>
              <th className={cx("th")}>제품명</th>
              <th className={cx("th")}>CAS_No</th>
              <th className={cx("th")}>포장단위</th>
              <th className={cx("th")}>설명</th>
              <th className={cx("th")}>작성일</th>
              <th className={cx("th")}>관리</th>
            </tr>
          </thead>
          <tbody>
            {data[currentPage]?.map((el) => (
              <tr key={el.id}>
                <td className={cx("td")}>{el.id}</td>
                <td className={cx("td")}>
                  {el?.locale === "ko" ? "한국어" : "영문"}
                </td>
                <td className={cx("td")}>{el?.category || "-"}</td>
                <td className={cx("td")}>{el?.product_name || "-"}</td>
                <td className={cx("td")}>{el?.cas_no || "-"}</td>
                <td className={cx("td")}>{el?.pack_unit || "-"}</td>
                <td className={cx("td")}>{el?.usage_text || "-"}</td>
                <td className={cx("td")}>
                  {dayjs(el?.created_at).format("YYYY.MM.DD")}
                </td>
                <td className={cx("td")}>
                  <button
                    onClick={() => handleDetailMove(el?.group_id)}
                    className={cx("table_button")}
                  >
                    상세보기
                  </button>
                  <button
                    onClick={() => handleDelete(el?.group_id)}
                    className={cx("table_button")}
                  >
                    삭제
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {total && total !== 0 ? (
        <Pagination
          currentPage={currentPage}
          lastPage={lastPage}
          perPage={perPage}
          handlePage={handlePage}
        />
      ) : (
        <div className={cx("empty_box")}>
          <p className={cx("empty_text")}>등록 된 품목이 없습니다.</p>
        </div>
      )}
      <div className={cx("button_box")}>
        <button onClick={() => handleDetailMove(null)} className={cx("button")}>
          품목 추가
        </button>
      </div>
    </>
  );
}
